/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useEffect } from "react";
import HeaderSection from "../../../common/headerSection";
import PageHeader from "../../../common/pageHeader";
import { Link } from "react-router-dom";
import CustomTable from "../../../../widgets/table";
import Pagination from "../../../../widgets/pagination";
import { TfiClose } from "react-icons/tfi";
import { Modal } from "react-bootstrap";
import { dashboardServices } from "../../../../service/dashboard";
import { useTranslation } from 'react-i18next';
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";


//column header for upcomming schedule
const columns : any  = [
  {
    Header: "Sl.No",
    accessor: "slno",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.locationName",
    accessor: "location_name",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.scheduleName",
    accessor: "schedule_name",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.policyName",
    accessor: "policy_name",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.duration",
    accessor: "duration",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.startTime",
    accessor: "start_time",
  },
  {
    Header: "dashboard.upcommingScheduleColumns.endTime",
    accessor: "end_time",
  },
]

const UpcommingSchedule = () => {

  const { t } = useTranslation();
  const [page, setpage] = useState(1)
  const [pagesize, setpagesize] = useState(DEFAULT_PAGE_SIZE)
  const [totalPages, settotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)
  const [scheduleDetails , setScheduleDetails] = useState<Array<any>>([]);
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [useEffectRequired, setUseEffectRequired] = useState(false)


  //handle table pagination 
  const handleSchedulePageChange = (newPage : any, pageSize?: number) => {
    setpage(newPage);
    if(pageSize) {
      setpagesize(pageSize)
    }
    setUseEffectRequired(true)
  }
  // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key)
    if (value) {
      setOrder("asc")
    } else {
      setOrder("desc")
    }
    setUseEffectRequired(true)
  }

//api calls to list missed schedules 
const getUpcomingScheduleDetails = async () => {
  try {
    const response = await dashboardServices.getUpcomingScheduleDetails(page, pagesize,sort,order);
    if(response.status && response.statusCode === 200){
      try {
          if ( Array.isArray(response.data) && response.data?.length > 0) {
            settotalPages(response?.totalPages)
            setTotalElements(response?.totalElements)
            let rowData: any = response.data.map((element: any, index: number) => {
              return { 
                  slno: index + 1,             
                  location_name : element.location_name,
                  schedule_name : element.schedule_name,
                  policy_name : element.policy_name,
                  duration : element.duration,
                  start_time : element.start_time,
                  end_time : element.end_time,            
              };
            });
            setScheduleDetails(rowData);
          }
        } catch (error) {
         
          console.log(error);
        }
    }else{
      setScheduleDetails([])
    }
  } catch (error) {
    console.error('exposure response', error);
  }
};

useEffect(() => {
  getUpcomingScheduleDetails();
}, [useEffectRequired])
  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t('dashboard.title')} />
      <nav aria-label="breadcrumb" className="breadcrumb-container">
        <ol className="breadcrumb">
          <li className="breadcrumb-item dashboard-hover">
            <Link to="/*">{t('dashboard.title')}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
          {t('dashboard.upcomming_schedule')}
          </li>
        </ol>
      </nav>

      <div className='col-md-12 mx-3 pe-5' style={{"height":"45vh"}}>
                <CustomTable
                    tableHead= {t('dashboard.upcomming_schedule')}
                    data={scheduleDetails} 
                    columns={columns} 
                    isEditable={false} 
                    isActionVisible={false} 
                    isViewVisible={false} 
                    totalElements={totalElements}
                    isSeachable={false}
                    isToggleStatus={false}  
                    onSortClick={handleSort}
                    onUseEffectRequired={() => setUseEffectRequired(true)}     
                />
        </div>
        <div>
              <Pagination
                page={page}
                totalPages={totalPages}
                handlePageChange={handleSchedulePageChange}
              />
        </div>
    </div>
  );
};

export default UpcommingSchedule;
